const styles = {
  viewer: {
    flexDirection: "column",
    display: "flex",
    width: "100vw",
    height: "100vh",
    background: "#040404",
    position: "fixed",
    top: 0,
    zIndex: 1000002,
  },
  topContainer: {
    boxSizing: "border-box",
    backgroundColor: "#040404",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    height: "56px",
    paddingLeft: "15px",
    paddingRight: "15px",
    boxShadow: "0 2px 4px 0 rgba(0,0,0,0.1)",
    position: "relative",
    "@media screen and (orientation: landscape)": {
      marginTop: "12px",
      marginBottom: "12px",
    },
  },
  counter: {
    color: "white",
    fontFamily: "CircularStd",
    fontSize: "16px",
    fontWeight: "300",
    letterSpacing: "0",
    display: "inline-block",
  },

  navigate: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    position: "fixed",
    top: "90vh",
    width: "calc(100% - 56px)",
    marginLeft: "28px",
    marginRight: "28px",
  },
  caret: {
    position: "relative",
    top: "6px",
    display: "inline-block",
  },

  rotate: {
    top: "-3px",
    transform: "rotate(180deg)",
  },
  videoTitle: {
    left: "24px",
    marginLeft: "10px",
    marginTop: "10px",
    color: "white",
    fontFamily: "CircularStd",
    fontSize: "20px",
    fontWeight: "500",
    letterSpacing: "0",
    lineHeight: "25px",
    textShadow: "2px 2px 2px rgba(0,0,0,0.5)",
  },
  description: {
    position: "fixed",
    height: "100vh",
    background: "rgba(0, 0, 0, 0.9)",
    zIndex: 1000006,
    overflowY: "scroll",
    top: 0,
    right: 0,
    transition: "0.3s all ease",
    width: "33.3%",
    "@media screen and (max-width : 767px) and (orientation: portrait)": {
      width: "100%",
    },
  },
  closeIcon: {
    position: "absolute",
    right: "1%",
    top: "1%",
    padding: "10px",

    zIndex: 1000007,
  },

  descriptionText: {
    position: "absolute",
    top: "84px",
    padding: "0 25px",
    color: "white",
    fontFamily: "CircularStd",
    fontSize: "16px",
    fontWeight: "300",
    letterSpacing: "0",
    lineHeight: "24px",
  },
};

export default styles;
